import classNames from 'classnames'
import React, { useContext } from 'react'
import { Trans, t } from '@lingui/macro'

import { linkBuilder } from 'shared/linkBuilder'
import { navigateTo } from '../../../../app/util/appHistory'
import IconTick from '../../../../components/common/icon/IconTick'
import StepsArrow from 'public/assets/img/steps_arrow.svg'
import './SurveyGuide.less'
import { ManageSurveyContext } from '../ManageSurveyContext'

const SurveysGuide = () => {
  const { survey } = useContext(ManageSurveyContext)

  // Don't show guide for active survey
  if (survey.published_at) {
    return null
  }

  const url = {
    summary: linkBuilder.surveyDetailManage(survey.id),
    create: `${linkBuilder.surveyDetailManage(survey.id)}/create`,
    send: `${linkBuilder.surveyDetailManage(survey.id)}/send`,
    result: `${linkBuilder.surveyDetailManage(survey.id)}/result`
  }

  return (
    <header className="Summary__guide">
      <h2>
        <Trans>This survey is a draft</Trans>
      </h2>
      <p>
        <Trans>
          In order to activate your survey you must add at least one question
          and define your audience
        </Trans>
      </p>

      <div className="Summary__steps">
        <a
          className={classNames('Summary__step', {
            active: survey.questions.length === 0,
            done: survey.questions.length > 0
          })}
          onClick={() => navigateTo(url.create)}
        >
          1. <Trans>Design your survey</Trans>{' '}
          {survey.questions.length > 0 && <IconTick />}
          <img src={StepsArrow} alt={t`Arrow right`} />
        </a>
        <a
          className={classNames('Summary__step', {
            active: survey.questions.length > 0,
            disabled: survey.questions.length === 0
          })}
          onClick={() => navigateTo(url.send)}
        >
          2. <Trans>Select your recipients</Trans>
          <img src={StepsArrow} alt={t`Arrow right`} />
        </a>
        <div className="Summary__step">
          3. <Trans>Activate your survey</Trans>
        </div>
      </div>
    </header>
  )
}

export default SurveysGuide
